<script>
	import { createEventDispatcher, onMount } from 'svelte'
	import { fly } from 'svelte/transition'

	import Modal from '../../components/Modal/Modal.svelte'
	import ModalOverlay from '../../components/Modal/ModalOverlay.svelte'
	import SmartField from '../../components/SmartField/SmartField.svelte'
	import userStore from '../../stores/user'
	import moment from 'moment'
	import axios from 'axios'
	import VirtualList from '../../components/VirtualList/VirtualList.svelte'
	import ListItem from '../../components/ListItem/ListItem.svelte'
	import ActionButton from '../../components/ActionButton/ActionButton.svelte'

	export let id

	let ctrlsDisabled = false,
		firstField = null,
		programs = [],
		clients = {},
		users = {},
		height = '360px'

	const dispatch = createEventDispatcher()

	const onCancel = () => {
		dispatch('cancel')
	}

	async function loadData() {
		const start = moment().subtract(30, 'days').valueOf()
		const end = moment().valueOf()
		const clientId = parseInt(id)
		await Promise.all(
			$userStore.sectorsList.map(async (category) => {
				const { data } = await axios.request({
					method: 'post',
					url: '/api/programs/olist',
					params: {
						category,
						start,
						end
					}
				})
				programs = [...programs, ...data.programs]
				clients = { ...clients, ...data.clients }
				users = { ...users, ...data.users }
			})
		)
		programs = programs
			.filter((program) => program.client === clientId)
			.sort((a, b) => b.date - a.date)
			.map((program) => {
				return {
					...program,
					client: clients[program.client],
					creator: users[program.creator],
					editedby: users[program.editedby],
					operators: program.operators.map((operator) => users[operator])
				}
			})
	}

	$: if ($userStore) loadData()
	$: if (firstField) firstField.focus()
	$: console.log('programs', programs)
</script>

<ModalOverlay />
<Modal classes="CreateLog" hideOverlay>
	<div class="Editor basic-panel-content">
		<div class="heading">Scegli programma</div>
		<VirtualList items={programs} {height} noresultText="Nessun programma trovato negli ultimi 30 giorni" let:item>
			<div class="OperatorItem clearfix">
				<ListItem
					classes="unsettled-programs block with-icon clearfix shadow-none border-b border-solid border-gray-700"
					actions
					on:click={dispatch('select', item)}
				>
					<div class="icon">
						<i class="fad {item.category === 1 ? 'fa-vacuum' : 'fa-bug'}"></i>
					</div>
					<div class="meta">
						<div class="lbl">{item.client.name} ({item.date_signature})</div>
						<div class="txt">{item.description}</div>
						<div class="flex flex-wrap gap-1 mt-1">
							{#each item.operators as operator}
								<div
									class="operator-item text-xs bg-darkgray-700 text-white rounded-xl px-2"
									class:settled={item.operators_done.includes(operator.token_id)}
								>
									{operator.name}
								</div>
							{/each}
						</div>
					</div>

					<div slot="actions">
						<ActionButton icon="far fa-check" on:click={dispatch('select', item)} />
					</div>
				</ListItem>
			</div>
		</VirtualList>
	</div>
	<div class="ctrls" in:fly={{ y: -60, duration: 300, delay: 300 }}>
		<button class="btn btn-sm btn-danger" disabled={ctrlsDisabled} on:click={onCancel}>Annulla</button>
	</div>
</Modal>

<style>
	:global(.CreateLog) .basic-panel-content {
		width: 600px;
		/* padding: 0; */
		position: relative;
		z-index: 2;
	}
	.heading {
		margin-bottom: 10px;
	}
	.ctrls {
		margin-top: 10px;
		text-align: left;
		position: relative;
		z-index: 1;
	}
	.ctrls :global(button) {
		padding: 0.4rem 1.3rem;
	}
	.ctrls :global(.btn) {
		margin-right: 5px;
	}

	:global(.ListItem.unsettled-programs) {
		border-radius: 0 !important;
	}

	.operator-item.settled {
		background-color: #31c7aa;
	}

	@media (max-width: 800px) {
		:global(.ProgramEditor) {
			width: 100%;
			height: 100%;
		}
		:global(.ProgramEditor) .basic-panel-content {
			width: calc(100% - 50px);
			left: 50px;
		}
	}
</style>
